import Repository from "./repository"

export default {
    get(){
        return Repository.get("/api/s207-customer-details/view")
    }
}